import { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';

export const SliderProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Carousel: {
              arrowSize: 11,
              dotWidth: 6,
              dotGap: 5,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </>
  );
};
